class ResultsFormatterBase{
    format(results){
        return results;
    }
}

export default ResultsFormatterBase;